import React, { useEffect, useState,  useContext } from "react";
import { Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { createDSO, updateDSO } from "../../../services/adminApiService/dsoAPIs/dsoApis";
import { DSOContext } from "../../../context/DSOContext";
import notify from "../../../utils/notification";
import swal from "sweetalert";
import { EyePasswordBtn } from "../../../common/ui/view/CustomEyePasswordBtn";


// Validation schema for form fields
const validationSchema = {
  name: {
    required: true,
    pattern: /^[A-Za-z\s]+$/,
     maxLength: 50,
    message: "Name is required and Non-numeric",
  },
  phone: {
    required: true,
    pattern: /^[6-9]\d{9}$/,
    message: "Enter a valid 10-digit phone number",
  },
  email: {
    required: true,
    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
    message: "Enter a valid email address",
  },
 password: {
  required: true,
  pattern: /^(?!.*[\s])(?=[A-Za-z0-9@#$!%*?&]+$)(?!.*([@#$!%*?&])\1{2,}).{6,15}$/,
  minLength: 8,
  maxLength: 15,
  message: "Invalid password.",
  requiredMessage: "Password is required",
},

  state: {
    required: true,
    message: "State is required",
  },
  district: {
    required: true,
    message: "District is required",
  },
  adminCateogry: {
    required: true,
    message: "Admin Category type",
  },
};

const CreateDSO = () => {
  const {
    loading,
    statesList,
    districtList,
    errors,
    setErrors,
    setFormData,
    formData,
    setIsLoading,
    fetchDSOs,
    showCreateDSO,
    handleClose,
    editData,
    adminCategoryTypeList,
    fetchAdminCategoryTypes,
  } = useContext(DSOContext);

  
 


  const [showPassword, setShowPassword] = useState(false);
  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Validate field on change
    validateField(name, value);
  };

  // Validation function

const validateField = (field, value) => {
  const rule = validationSchema[field];
  if (!rule) return;

  // Convert value to string safely
  const stringValue = value !== undefined && value !== null ? String(value) : "";

  const trimmedValue = stringValue.trim();

 if (rule.required && !trimmedValue) {
  setErrors((prev) => ({
    ...prev,
    [field]: rule.requiredMessage || "Password is required",
  }));
} else if (rule.maxLength && trimmedValue.length > rule.maxLength) {
  setErrors((prev) => ({
    ...prev,
    [field]: `Maximum ${rule.maxLength} characters allowed`,
  }));
} else if (rule.minLength && trimmedValue.length < rule.minLength) {
  setErrors((prev) => ({
    ...prev,
    [field]: `Password must be at least ${rule.minLength} characters`,
  }));
} else if (rule.pattern && !rule.pattern.test(trimmedValue)) {
  setErrors((prev) => ({
    ...prev,
    [field]: "Invalid password.",
  }));
} else {
  setErrors((prev) => {
    const newErrors = { ...prev };
    delete newErrors[field];
    return newErrors;
  });
}


};

  
  const validateForm = () => {
    const newErrors = {};
    Object.keys(validationSchema).forEach((field) => {
      validateField(field, formData[field]);
      if (!formData[field]) {
        newErrors[field] = validationSchema[field].message;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const payload = {
        name: formData.name,
        phone: formData.phone,
        email: formData.email,
        password: formData.password,
        state: formData.state,
        district: parseInt(formData.district),
        category_id: formData.adminCateogry,
      };

      try {
        setIsLoading(true);

        const response = editData
          ? await updateDSO(editData?.id, payload)
          : await createDSO(payload);

        if (response?.data?.status === true) {
          swal("Success", response?.data?.message, "success");
          setFormData({});
          fetchDSOs();
          handleClose();
        } else {
          // ✅ NEW: handle backend field errors here also
          if (response?.data?.errors) {
            const backendErrors = response.data.errors;
            const formattedErrors = {};
            for (const field in backendErrors) {
              if (backendErrors.hasOwnProperty(field)) {
                formattedErrors[field] = backendErrors[field][0];
              }
            }

           
            setErrors((prevErrors) => ({ ...prevErrors, ...formattedErrors }));
          } else {
            notify("error", response?.data?.message || "Something went wrong");
          }
        }
      } catch (error) {
        // ✅ Check if backend sent field-level errors
        if (error.response?.data?.errors) {
          const backendErrors = error.response.data.errors;
          const formattedErrors = {};

          Object.keys(backendErrors).forEach((field) => {
            formattedErrors[field] = backendErrors[field][0]; // take first error message
          });

          setErrors(formattedErrors); // will show under inputs
        } else if (error.response?.data?.message) {
          notify("error", error.response.data.message);
        } else {
          notify("error", "An unexpected error occurred. Please try again.");
        }
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchAdminCategoryTypes()
  }, [])

  return (
    <Modal show={showCreateDSO} onHide={handleClose} backdrop="true" centered>
      <form onSubmit={handleSubmit}>
        <div className="modal-header">
          <h4 className="modal-title fs-20">
            {editData ? "Edit DSO" : "Add DSO"}
          </h4>
          <button type="button" className="btn-close" onClick={handleClose}>
            <span></span>
          </button>
        </div>
        <div className="modal-body">
          <div className="add-contact-box">
            <div className="add-contact-content">
              <div className="row">
                {[
                  {
                    label: "Name",
                    name: "name",
                    type: "text",
                    placeholder: "DSO Full Name",
                  },
                  {
                    label: "Phone",
                    name: "phone",
                    type: "tel",
                    placeholder: "DSO Contact Number",
                  },
                  {
                    label: "Email",
                    name: "email",
                    type: "email",
                    placeholder: "DSO Email",
                  },
                  {
                    label: "Password",
                    name: "password",
                    type: "password",
                    placeholder: "DSO Password",
                  },
                ].map(({ label, name, type, placeholder }) => (
                  <div key={name} className="col-md-6 mb-3">
                    <label className="text-black font-w500">
                      {label} <span className="text-danger">*</span>
                    </label>
                    <div className="password-input-container">
                      <Form.Control
                        type={name === "password" ? (showPassword ? "text" : "password") : type}
                        name={name}
                        value={formData[name]}
                        placeholder={placeholder}
                        onChange={handleChange}
                        isInvalid={!!errors[name]}
                       
                      />
                      {name === "password" && (
                        <EyePasswordBtn
                          showPassword={showPassword}
                          setShowPassword={setShowPassword}
                           hasError={!!errors[name]}
                        />
                      )}

                    </div>

                    <Form.Control.Feedback type="invalid"  className="d-block">
                      {errors[name] ||  errors?.[name]}
                    </Form.Control.Feedback>
                  

                  </div>
                ))}
              </div>

              <div className="row">
                <div className="form-group mb-3 col-md-6">
                  <label className="text-black font-w500">
                    State <span className="text-danger">*</span>
                  </label>
                  <select
                    name="state"
                    className={`form-control ${errors.state ? "is-invalid" : ""
                      }`}
                    value={formData.state}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select State</option>
                    {statesList.map((state) => (
                      <option key={state.id} value={state.id}>
                        {state.name}
                      </option>
                    ))}
                  </select>
                  <div className="invalid-feedback">{errors.state}</div>
                </div>

                <div className="form-group mb-3 col-md-6">
                  <label className="text-black font-w500">
                    District <span className="text-danger">*</span>
                  </label>
                  <select
                    name="district"
                    className={`form-control ${errors.district ? "is-invalid" : ""
                      }`}
                    value={formData.district}
                    onChange={handleChange}
                    disabled={!formData.state}
                    required
                  >
                    <option value="">Select District</option>
                    {districtList.map((district) => (
                      <option key={district.id} value={district.id}>
                        {district.name}
                      </option>
                    ))}
                  </select>
                  <div className="invalid-feedback">{errors.district}</div>
                </div>

                <div className="form-group mb-3 col-md-6">
                  <label className="text-black font-w500">
                    Admin  Category type <span className="text-danger">*</span>
                  </label>
                  <select
                    name="adminCateogry"
                    className={`form-control ${errors.adminCateogry ? "is-invalid" : ""
                      }`}
                    value={formData.adminCateogry}
                    onChange={handleChange}
                    // disabled={!formData.adminCateogry}
                    required
                  >
                    <option value="">Select Admin  Category type</option>
                    {adminCategoryTypeList?.map((item) => (
                      <option key={item.id} value={item?.id}>
                        {item?.category_name}
                      </option>
                    ))}
                  </select>
                  <div className="invalid-feedback">{errors.adminCateogry}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer d-flex justify-content-between">
          <Button
            type="reset"
            className="btn btn-secondary mx-2"
            onClick={() => setFormData({})}
          >
            Reset
          </Button>
          <Button
            type="submit"
            className="btn btn-primary mx-2"
            disabled={Object.keys(errors).length > 0 || loading}
          >
           {loading ? "Saving..." : "Save"}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default CreateDSO;
